var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.00012207,
    width: 48,
    height: 48.96,
    rx: 16,
    fill: "#201E26"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11.9999,
    width: 16,
    height: 24,
    rx: 5,
    fill: "#A1A3B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.2499C19.5858 23.2499 19.25 23.5857 19.25 23.9999C19.25 24.4141 19.5858 24.7499 20 24.7499L20 23.2499ZM36.5303 24.5302C36.8232 24.2373 36.8232 23.7624 36.5303 23.4695L31.7574 18.6966C31.4645 18.4037 30.9896 18.4037 30.6967 18.6966C30.4038 18.9895 30.4038 19.4643 30.6967 19.7572L34.9393 23.9999L30.6967 28.2425C30.4038 28.5354 30.4038 29.0103 30.6967 29.3032C30.9896 29.5961 31.4645 29.5961 31.7574 29.3032L36.5303 24.5302ZM20 24.7499L36 24.7499L36 23.2499L20 23.2499L20 24.7499Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogout);
export default __webpack_public_path__ + "static/media/sidebar_logout.1628a72a.svg";
export { ForwardRef as ReactComponent };